export const normalizeMatchedProgramChoices = (question) =>
  (Array.isArray(question?.answer_choices) ? question.answer_choices : [])
    .filter((choice) => choice && typeof choice === "object" && choice.program_id)
    .map((choice) => ({
      ...choice,
      value: String(choice.value || choice.program_id),
      program_id: String(choice.program_id),
      label: choice.label || choice.name || "Treatment Program",
      description: choice.description || "",
      matching_rule: choice.matching_rule || {},
      eligibility: choice.eligibility || {},
      service_states: Array.isArray(choice.service_states) ? choice.service_states : [],
      disqualifying_rules: Array.isArray(choice.disqualifying_rules) ? choice.disqualifying_rules : [],
    }));
